module.exports = __webpack_public_path__ + "media/images/icons/manage-d402a2536b155b273d0d2bbece4b4865.svg";